import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// Expected data shape:
// [
//   { date: '2025-01-01', counts: 4 },
//   { date: '2025-01-02', counts: 7 }
// ]

const ClientRegistrationsChart = ({ data }) => {
    const { labels, dataset } = useMemo(() => {
        const labelsLocal = (data || []).map((d) => d.date);
        const datasetLocal = (data || []).map((d) => (typeof d?.counts === 'number' ? d.counts : 0));
        return { labels: labelsLocal, dataset: datasetLocal };
    }, [data]);

    const chartData = {
        labels,
        datasets: [
            {
                label: 'New clients',
                data: dataset,
                borderColor: '#1a73e8',
                backgroundColor: 'rgba(26, 115, 232, 0.2)',
                pointBackgroundColor: '#1a73e8',
                pointBorderColor: '#1a73e8',
                fill: false,
                tension: 0.25,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { position: 'top' },
            title: { display: true, text: 'New clients' },
            tooltip: { intersect: false, mode: 'index' },
        },
        interaction: { intersect: false, mode: 'nearest' },
        scales: {
            x: { grid: { display: false } },
            y: { beginAtZero: true, ticks: { precision: 0 } },
        },
    };

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <Line data={chartData} options={options} />
        </div>
    );
};

export { ClientRegistrationsChart };


